import React from 'react';
import { Droppable, Draggable } from "react-beautiful-dnd";
import ListingCard from '../Components/ListingCard';
import { useSelector } from 'react-redux';

const Plan = ({ id }) => {
    const listings_data = useSelector((state) => state.webpage_detail.listings);

    return (
        <Droppable droppableId={id} type="PLANS">
            {(provided) => {
                return (
                    <div ref={provided.innerRef}>
                        {listings_data.plans_data?.plans?.map((item, index) => {
                            return (
                                <Draggable
                                    key={`plans-${index}`}
                                    draggableId={`plans-${index}`}
                                    index={index}
                                >
                                    {(provided) => (
                                        <>
                                            <div ref={provided.innerRef} {...provided.draggableProps} className={`col-12 bottom_margin`}>
                                                <ListingCard item={item} index={index} provided={provided} />
                                            </div>
                                            {provided.placeholder}
                                        </>
                                    )}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </div>
                );
            }}
        </Droppable>
    )
}

export default Plan;